interface SummaryCardsProps {
  totalAllocated: number;
  totalSpent: number;
  remainingBudget: number;
  utilizationPercent: number;
  fiscalYear?: string;
}

function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function SummaryCards({
  totalAllocated,
  totalSpent,
  remainingBudget,
  utilizationPercent,
  fiscalYear = 'FY 2026',
}: SummaryCardsProps) {
  return (
    <div style={{ 
      backgroundColor: '#ffffff',
      border: '1px solid #ddd',
      borderRadius: '6px',
      padding: '18px 24px',
      marginBottom: '18px',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Total Budget Allocated */}
      <div style={{ 
        padding: '14px 0',
        paddingLeft: '14px',
        borderLeft: '4px solid #1a3bcc',
        borderBottom: '1px solid #eee',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <p style={{ fontSize: '10px', fontWeight: '600', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', margin: '0 0 4px 0' }}>
          Total Budget Allocated
        </p>
        <p style={{ fontSize: '28px', fontWeight: '900', color: '#1a3bcc', margin: '0 0 2px 0' }}>{formatCurrency(totalAllocated)}</p>
        <p style={{ fontSize: '11px', color: '#999', margin: '2px 0 0 0' }}>Across all BRGs · {fiscalYear}</p>
      </div>

      {/* Total Amount Spent */}
      <div style={{ 
        padding: '14px 0',
        paddingLeft: '14px',
        borderLeft: '4px solid #1a3bcc',
        borderBottom: '1px solid #eee',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <p style={{ fontSize: '10px', fontWeight: '600', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', margin: '0 0 4px 0' }}>
          Total Amount Spent
        </p>
        <p style={{ fontSize: '28px', fontWeight: '900', color: '#1a3bcc', margin: '0 0 2px 0' }}>{formatCurrency(totalSpent)}</p>
        <p style={{ fontSize: '11px', color: '#999', margin: '2px 0 0 0' }}>{utilizationPercent}% of total allocation</p>
      </div>

      {/* Remaining Budget */}
      <div style={{ 
        padding: '14px 0',
        paddingLeft: '14px',
        borderLeft: '4px solid #1a7c3a',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <p style={{ fontSize: '10px', fontWeight: '600', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', margin: '0 0 4px 0' }}>
          Remaining Budget
        </p>
        <p style={{ fontSize: '28px', fontWeight: '900', color: '#1a7c3a', margin: '0 0 2px 0' }}>{formatCurrency(remainingBudget)}</p>
        <p style={{ fontSize: '11px', color: '#999', margin: '2px 0 0 0' }}>{100 - utilizationPercent}% remaining this fiscal year</p>
      </div>
    </div>
  );
}
